import { gql } from '@apollo/client';

const SEARCH_ADMIN = () => gql`
  query searchAdmin($limit: Int, $offset: Int, $sort: String, $rawQuery: JSON!) {
    search: searchAdmin(limit: $limit, offset: $offset, sort: $sort, rawQuery: $rawQuery) {
      jsonResults
      total
    }
  }
`;

const SEARCH_PUBLISHED = ({ resultKeys }) => gql`
  query searchPublishedContent($limit: Int, $offset: Int, $sort: String, $rawQuery: JSON!) {
    search: searchPublishedContent(
      limit: $limit
      offset: $offset
      sort: $sort
      rawQuery: $rawQuery
    ) {
      results {
        ...on ContentContentInterface {
          ${resultKeys}
        }  
      }
      total
    }
  }
`;

export default { SEARCH_ADMIN, SEARCH_PUBLISHED };
